export default [
  {
    header: 'Pendaftaran',
    action: 'read',
    resource: 'head-pendaftaran',
  },
  {
    title: 'Pengajuan Cuti',
    route: 'pengajuan-cuti-baru',
    icon: 'EditIcon',
    action: 'create',
    resource: 'pengajuan-cuti-baru',
  },
  {
    header: 'Daftar Riwayat Cuti',
    action: 'read',
    resource: 'head-daftar-riwayat-cuti',
  },
  {
    title: 'Daftar List Cuti',
    route: 'daftar-list-cuti',
    icon: 'BookIcon',
    action: 'read',
    resource: 'daftar-list-cuti',
  },
  // {
  //   title: 'Surat Cuti',
  //   route: 'surat-cuti',
  //   icon: 'FileTextIcon',
  //   action: 'read',
  //   resource: 'daftar-surat-cuti',
  // },
  {
    header: 'Master',
    action: 'read',
    resource: 'pengguna',
  },
  {
    title: 'Pegawai',
    route: 'list-pegawai',
    icon: 'UserIcon',
    action: 'read',
    resource: 'pengguna',
  },
  {
    title: 'Sisa Cuti',
    route: 'sisa-cuti-update',
    icon: 'FileTextIcon',
    action: 'read',
    resource: 'pengguna',
  },
  // {
  //   title: 'Daftar Hasil Sidang',
  //   route: 'hasil-sidang',
  //   icon: 'AirplayIcon',
  //   action: 'read',
  //   resource: 'hasil-sidang',
  // },
  // {
  //   header: 'Yudisium',
  //   action: 'head',
  //   resource: 'yudisium',
  // },
  // {
  //   title: 'Pengajuan Yudisium',
  //   route: 'pengajuan-yudisium',
  //   icon: 'EditIcon',
  //   action: 'read',
  //   resource: 'yudisium',
  // },
  // {
  //   title: 'Daftar List Yudisium',
  //   route: 'daftar-yudisium',
  //   icon: 'BookIcon',
  //   action: 'read',
  //   resource: 'yudisium',
  // },
  // {
  //   header: 'Surat',
  //   action: 'read',
  //   resource: 'surat',
  // },
  // {
  //   title: 'Surat Tugas Penguji',
  //   route: 'surat-tugas',
  //   icon: 'FileIcon',
  //   action: 'read',
  //   resource: 'surat-tugas',
  // },
  // {
  //   title: 'Nota Dinas',
  //   route: 'nota-dinas',
  //   icon: 'FileIcon',
  //   action: 'read',
  //   resource: 'nota-dinas',
  // },
  // // {
  // //   title: 'Surat Tugas Pembimbing',
  // //   route: 'surat-tugas-pembimbing',
  // //   icon: 'FileIcon',
  // //   action: 'read',
  // //   resource: 'surat-tugas-pembimbing',
  // // },
  // // {
  // //   title: 'SKTMT',
  // //   route: 'sktmt',
  // //   icon: 'FileIcon',
  // //   action: 'read',
  // //   resource: 'sktmt',
  // // },
  // {
  //   header: 'Manajemen',
  //   action: 'read',
  //   resource: 'manajemen',
  // },
  // {
  //   title: 'Akses',
  //   icon: 'UserCheckIcon',
  //   children: [
  //     {
  //       title: 'Pengguna',
  //       route: 'pengguna',
  //       resource: 'pengguna',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Hak Akses',
  //       route: 'hak-akses',
  //       resource: 'hak-akses',
  //       action: 'read',
  //     },
  //   ],
  // },
  // {
  //   header: 'Data Master',
  //   action: 'read',
  //   resource: 'data-master',
  // },
  // {
  //   title: 'Periode Ujian',
  //   route: 'periode-ujian',
  //   icon: 'BookOpenIcon',
  //   action: 'read',
  //   resource: 'periode-ujian',
  // },
  // {
  //   title: 'Sync Dosen',
  //   route: 'sync-dosen',
  //   icon: 'RefreshCwIcon',
  //   action: 'read',
  //   resource: 'sync-dosen',
  // },
  // {
  //   title: 'Master',
  //   icon: 'ArchiveIcon',
  //   children: [
  //     {
  //       title: 'Dosen',
  //       route: 'dosen',
  //       resource: 'dosen',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Jenjang',
  //       route: 'jenjang',
  //       resource: 'jenjang',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Prodi',
  //       route: 'prodi',
  //       resource: 'prodi',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Peminatan',
  //       route: 'peminatan',
  //       resource: 'peminatan',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Program',
  //       route: 'program',
  //       resource: 'program',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Ruangan',
  //       route: 'ruangan',
  //       resource: 'ruangan',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Waktu Ujian',
  //       route: 'waktu-ujian',
  //       resource: 'waktu-ujian',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Status Hasil Sidang',
  //       route: 'status-hasil-sidang',
  //       resource: 'status-hasil-sidang',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Status Jadwal Sidang',
  //       route: 'status-jadwal-sidang',
  //       resource: 'status-jadwal-sidang',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Status Pengajuan Sidang',
  //       route: 'status-pengajuan-sidang',
  //       resource: 'status-pengajuan-sidang',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Proses Persidangan',
  //       route: 'proses-persidangan',
  //       resource: 'proses-persidangan',
  //       action: 'read',
  //     },
  //     {
  //       title: 'Notifikasi Email',
  //       route: 'notifikasi-email',
  //       resource: 'notifikasi-email',
  //       action: 'read',
  //     },
  //   ],
  // },
  // {
  //   header: 'Rekapitulasi',
  //   action: 'read',
  //   resource: 'rekapitulasi',
  // },
  // {
  //   title: 'Rekap Pengajuan Sidang',
  //   route: 'rekapitulasi-pengajuan-sidang',
  //   resource: 'rekapitulasi-pengajuan-sidang',
  //   action: 'read',
  // },
  // {
  //   title: 'Rekap Payroll',
  //   route: 'rekapitulasi-payroll',
  //   resource: 'rekapitulasi-payroll',
  //   action: 'read',
  // },
  // {
  //   title: 'Rekap Jadwal Sidang',
  //   route: 'rekapitulasi-jadwal-sidang',
  //   resource: 'rekapitulasi-jadwal-sidang',
  //   action: 'read',
  // },
  // {
  //   header: 'Jadwal External',
  //   action: 'read',
  //   resource: 'jadwal-external-umum',
  // },
  // {
  //   title: 'Jadwal External Umum',
  //   route: 'jadwal-external-umum',
  //   resource: 'jadwal-external-umum',
  //   action: 'read',
  // },
  // {
  //   header: 'Apps & Pages',
  // },
  // {
  //   title: 'Email',
  //   route: 'apps-email',
  //   icon: 'MailIcon',
  // },
  // {
  //   title: 'Chat',
  //   route: 'apps-chat',
  //   icon: 'MessageSquareIcon',
  // },
  // {
  //   title: 'Todo',
  //   route: 'apps-todo',
  //   icon: 'CheckSquareIcon',
  // },
  // {
  //   title: 'Calendar',
  //   route: 'apps-calendar',
  //   icon: 'CalendarIcon',
  // },
  // {
  //   title: 'Invoice',
  //   icon: 'FileTextIcon',
  //   children: [
  //     {
  //       title: 'List',
  //       route: 'apps-invoice-list',
  //     },
  //     {
  //       title: 'Preview',
  //       route: { name: 'apps-invoice-preview', params: { id: 4987 } },
  //     },
  //     {
  //       title: 'Edit',
  //       route: { name: 'apps-invoice-edit', params: { id: 4987 } },
  //     },
  //     {
  //       title: 'Add',
  //       route: { name: 'apps-invoice-add' },
  //     },
  //   ],
  // },
  // {
  //   title: 'eCommerce',
  //   icon: 'ShoppingCartIcon',
  //   children: [
  //     {
  //       title: 'Shop',
  //       route: 'apps-e-commerce-shop',
  //     },
  //     {
  //       title: 'Details',
  //       route: { name: 'apps-e-commerce-product-details', params: { slug: 'apple-watch-series-5-27' } },
  //     },
  //     {
  //       title: 'Wishlist',
  //       route: 'apps-e-commerce-wishlist',
  //     },
  //     {
  //       title: 'Checkout',
  //       route: 'apps-e-commerce-checkout',
  //     },
  //   ],
  // },
  // {
  //   title: 'User',
  //   icon: 'UserIcon',
  //   children: [
  //     {
  //       title: 'List',
  //       route: 'apps-users-list',
  //     },
  //     {
  //       title: 'View',
  //       route: { name: 'apps-users-view', params: { id: 21 } },
  //     },
  //     {
  //       title: 'Edit',
  //       route: { name: 'apps-users-edit', params: { id: 21 } },
  //     },
  //   ],
  // },
  // {
  //   title: 'Pages',
  //   icon: 'FileIcon',
  //   children: [
  //     {
  //       title: 'Authentication',
  //       icon: 'CircleIcon',
  //       children: [
  //         {
  //           title: 'Login v1',
  //           route: 'auth-login-v1',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Login v2',
  //           route: 'auth-login-v2',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Register v1',
  //           route: 'auth-register-v1',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Register v2',
  //           route: 'auth-register-v2',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Forgot Password v1',
  //           route: 'auth-forgot-password-v1',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Forgot Password v2',
  //           route: 'auth-forgot-password-v2',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Reset Password v1',
  //           route: 'auth-reset-password-v1',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Reset Password v2',
  //           route: 'auth-reset-password-v2',
  //           target: '_blank',
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Account Settings',
  //       route: 'pages-account-setting',
  //     },
  //     {
  //       title: 'Profile',
  //       route: 'pages-profile',
  //     },
  //     {
  //       title: 'Faq',
  //       route: 'pages-faq',
  //     },
  //     {
  //       title: 'Knowledge Base',
  //       route: 'pages-knowledge-base',
  //     },
  //     {
  //       title: 'Pricing',
  //       route: 'pages-pricing',
  //     },
  //     {
  //       title: 'Blog',
  //       children: [
  //         {
  //           title: 'List',
  //           route: 'pages-blog-list',
  //         },
  //         {
  //           title: 'Detail',
  //           route: { name: 'pages-blog-detail', params: { id: 1 } },
  //         },
  //         {
  //           title: 'Edit',
  //           route: { name: 'pages-blog-edit', params: { id: 1 } },
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Mail Templates',
  //       children: [
  //         {
  //           title: 'Welcome',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-welcome.html',
  //         },
  //         {
  //           title: 'Reset Password',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-reset-password.html',
  //         },
  //         {
  //           title: 'Verify Email',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-verify-email.html',
  //         },
  //         {
  //           title: 'Deactivate Account',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-deactivate-account.html',
  //         },
  //         {
  //           title: 'Invoice',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-invoice.html',
  //         },
  //         {
  //           title: 'Promotional',
  //           href: 'https://pixinvent.com/demo/vuexy-mail-template/mail-promotional.html',
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Miscellaneous',
  //       icon: 'CircleIcon',
  //       children: [
  //         {
  //           title: 'Coming Soon',
  //           route: 'misc-coming-soon',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Not Authorized',
  //           route: 'misc-not-authorized',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Under Maintenance',
  //           route: 'misc-under-maintenance',
  //           target: '_blank',
  //         },
  //         {
  //           title: 'Error',
  //           route: 'misc-error',
  //           target: '_blank',
  //         },
  //       ],
  //     },
  //   ],
  // },
]
